module.exports = __webpack_public_path__ + "img/rapanui.9e4b9479.svg";